import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M5 5a2.48 2.48 0 0 0-2.019 1.038c-.305.422-.17 1.021.271 1.296l10.977 6.84c.472.296 1.07.296 1.543 0l10.93-6.899a.92.92 0 0 0 .234-1.342A2.48 2.48 0 0 0 25 5zm21.895 5.107a.6.6 0 0 0-.31.093L15.77 17.02a1.46 1.46 0 0 1-1.543-.002L3.414 10.278a.598.598 0 0 0-.913.508V22.5A2.5 2.5 0 0 0 5 25h20a2.5 2.5 0 0 0 2.5-2.5V10.706a.6.6 0 0 0-.605-.599" }, null, -1)
  ]))]))
}
export default { render: render }